import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import messages from '@/modules/tasks/taskMessages';
import { useGetTaskTemplates } from '@/shared/hooks/task/useGetTaskTemplates';
import guid from '@/shared/utils/guid';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
export const TaskTemplateSelect = ({ initialValue, placeholder, onChange, includeWithoutTemplate = true, useTemplateInCallback = false, }) => {
    const { formatMessage } = useIntl();
    const { data } = useGetTaskTemplates();
    const taskTemplates = useMemo(() => data === null || data === void 0 ? void 0 : data.map(item => ({
        key: item.id,
        label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
        resourceId: item.resourceId,
    })).sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase())), [data, formatMessage]);
    const items = useMemo(() => {
        if (!taskTemplates)
            return undefined;
        return includeWithoutTemplate
            ? [{ key: guid.empty, label: formatMessage(messages.TasksWithoutTemplate) }, ...taskTemplates]
            : taskTemplates;
    }, [formatMessage, taskTemplates, includeWithoutTemplate]);
    const initialSelectedItem = useMemo(() => { var _a; return (_a = (initialValue && (items === null || items === void 0 ? void 0 : items.find(item => (item === null || item === void 0 ? void 0 : item.key) === initialValue)))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, items]);
    return (_jsx(AutoComplete, { items: items, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(useTemplateInCallback ? item : item === null || item === void 0 ? void 0 : item.key) }));
};
export const FilterTaskTemplateSelect = ({ item, clearItems, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(TaskTemplateSelect, { onChange: value => setFilter((clearItems && !value
            ? Object.assign({ [item]: undefined }, clearItems.reduce((prev, clearItem) => (Object.assign(Object.assign({}, prev), { [clearItem]: undefined })), {})) : { [item]: value !== null && value !== void 0 ? value : undefined })), initialValue: activeFilters[item], placeholder: label })),
});
